<template>
    <div class="single-study" v-if="result && result.hellos && result.hellos.data && result.hellos.data.length > 0" id="content">

        <div class="single-study__intro">
            <div class="wrapper">
                <h1 class="animated-heading"
                    data-gsap-type="chars"
                    data-gsap-duration="0.3" 
                    data-gsap-stagger="0.04"
                    data-gsap-distance="50"
                    data-gsap-initial-scale="0.7">
                    {{result.hellos.data[0].attributes.Title}}
                </h1>
                <p class="animated-heading"
                    data-gsap-type="lines"
                    data-gsap-duration="0.6" 
                    data-gsap-stagger="0.04"
                    data-gsap-distance="50"
                    data-gsap-delay="0.3"
                    data-gsap-initial-scale="1">
                    {{result.hellos.data[0].attributes.caption}}
                </p>
                <div class="single-study__logo" v-if="result.hellos.data[0].attributes.Logo?.data?.attributes?.url">
                    <figure>
                        <SafeImage 
                            :imageData="result.hellos.data[0].attributes.Logo"
                            :placeholder="PLACEHOLDER_IMAGES.CLIENT_LOGO"
                            placeholderText="Client logo not available"
                            imageClass="case-study-logo"
                        />
                    </figure>
                </div>
            </div>

            <figure class="single-study__featured-image">
                <SafeImage 
                    :imageData="result.hellos.data[0].attributes.SingleImage"
                    :placeholder="PLACEHOLDER_IMAGES.CASE_STUDY"
                    placeholderText="Featured image not available"
                    imageClass="case-study-featured-image"
                />
            </figure>
        </div>

        <div class="content" >
            <div class="flex__element"  v-for="(component, index) in result.hellos.data[0].attributes.flexContent" v-if=" result.hellos.data[0].attributes.flexContent">
                <component :is="`flex-${component.__typename}`" :componentData="component"/>
            </div>
        </div>

        <div class="agency__hireus marquee__holder hire-us__holder background-image-holder">
            <div class="wrapper">
                <intro-component :intro="result.hellos.data[0].attributes.HireUs.Intro" :index="1" :isAnimated="true"></intro-component>
                <button-component  :button="result.hellos.data[0].attributes.HireUs.Button" classes="main-accent" data-gsap="fadeIn" data-gsap-initial-scale="1" data-gsap-delay="0.4" data-gsap-duration="0.2"></button-component>
            </div>

            <div class="marquee">
                Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/
            </div>

            <span class="contact-noise"></span>
            <span class="contact-background"></span>

        </div>

        <Seo v-if="result && result.hellos.data.length > 0 && result.hellos.data[0].attributes.seo" :seoData="result.hellos.data[0].attributes.seo"/>

    </div>

</template>

<script lang="ts">

    import { defineComponent, ref, watch } from 'vue';
    import { useQuery } from '@vue/apollo-composable';
    import { SINGLE_HELLO_BY_SLUG } from '../../graphql/single-hello-by-slug';

    import SafeImage from '../../components/SafeImage.vue'
    import { PLACEHOLDER_IMAGES } from '../../composables/useImageErrorHandler'

    import FlexComponentContentVideo                from "../../components/flex-content/Video.vue"
    import FlexComponentContentGridImages           from "../../components/flex-content/GridImages.vue"
    import FlexComponentContentImageCarousel        from "../../components/flex-content/ImageCarousel.vue"
    import FlexComponentContentLargeFact            from "../../components/flex-content/LargeFact.vue"
    import FlexComponentContentQuote                from "../../components/flex-content/Quote.vue"
    import FlexComponentContentSingleImage          from "../../components/flex-content/SingleImage.vue"
    import FlexComponentContentThreeColumnsFacts    from "../../components/flex-content/ThreeColumnsFacts.vue"
    import FlexComponentContentTwoColumns           from "../../components/flex-content/TwoColumns.vue"
    import FlexComponentContentTwoColumnsFacts      from "../../components/flex-content/TwoColumnsFacts.vue"
    import FlexComponentContentTwoColumnsText       from "../../components/flex-content/TwoColumnsText.vue"
    import FlexComponentContentWebsiteCta           from "../../components/flex-content/WebsiteCta.vue"
    import FlexComponentContentQuoteSmall           from "../../components/flex-content/QuoteSmall.vue"
    import FlexComponentContentContentIntro         from "../../components/flex-content/ContentIntro.vue"
    import ContactSquares          from "../../components/svg/ContactSquares.vue"
    import ContactQuitar          from "../../components/svg/ContactQuitar.vue"
    import LongArrow from "../../components/svg/LongArrow.vue"
    import BadgeIcon from "../../components/svg/BadgeIcon.vue"

    import ButtonComponent from '../../components/ButtonComponent.vue'
    import IntroComponent from '../../components/IntroComponent.vue'
    import Seo from '../../components/navigation/Seo.vue'

    import ConnectBackground from "../../components/svg/ConnectBackground.vue"

    export default defineComponent({
        components: {
            SafeImage,
            FlexComponentContentVideo,
            FlexComponentContentGridImages,
            FlexComponentContentImageCarousel,
            FlexComponentContentLargeFact,
            FlexComponentContentSingleImage,
            FlexComponentContentThreeColumnsFacts,
            FlexComponentContentTwoColumns,
            FlexComponentContentTwoColumnsFacts,
            FlexComponentContentTwoColumnsText,
            FlexComponentContentWebsiteCta,
            FlexComponentContentQuote,
            FlexComponentContentQuoteSmall,
            FlexComponentContentContentIntro,
            ButtonComponent,
            IntroComponent,
            ContactSquares,
            ContactQuitar,
            LongArrow,
            BadgeIcon,
            Seo,
            ConnectBackground,
        },
        props: {
            helloSlug: {
                type: String,
                required: true,
            },
        },
        setup(props) {
            const homeurl: string = import.meta.env.VITE_API_URL;
            const hello = ref(null);
            
            // Query hello by slug
            const { result, loading, error } = useQuery(SINGLE_HELLO_BY_SLUG, {
                slug: props.helloSlug,
            });

            // Watch for query completion and redirect if no results
            watch([result, loading], ([newResult, newLoading]) => {
                if (!newLoading && newResult && newResult.hellos && newResult.hellos.data && newResult.hellos.data.length === 0) {
                    // Use window.location for hard redirect to ensure proper page load
                    window.location.href = '/404';
                }
            }, { immediate: true });

            return {
                result,
                hello,
                homeurl,
                loading,
                error,
                PLACEHOLDER_IMAGES
            };
        },

    });

</script>
